import { LegalLayout } from "./layout"

export function TermsPage() {
  return (
    <LegalLayout title="Hizmet şartları">
      <p>
        Bu sayfa Hirefy platformunun hizmet şartlarını içerir. Detaylı metin için
        <code className="mx-1">app/(marketing)/legal/terms/page.tsx</code> içeriği FastAPI
        backend'ine taşındığında bu sayfa CMS'siz olarak güncellenir.
      </p>
    </LegalLayout>
  )
}
